<template>

<v-form ref="form" @submit.prevent="save">
    <v-row no-gutters class="mb-3" v-if="wizard" align="center">
    <wizard-stepper id="pfid1618819277" :steps="wizardSteps" class="flex-grow-1 flex-shrink-1" :step="step" :allow-editable="allowEditable" :last-editable-step="lastEditableStep" @click-step="$emit('click-step',$event)" />
    <v-btn v-if="!hideCancel" large class="pfcl1618819249 mx-5" @click="$emit('cancel')"><v-icon left>$close</v-icon>{{$t('form.cancelWizard')}}</v-btn>
    <v-btn :loading="saving" large class="pfcl1618819248 mr-5" type="submit" @click="nwSave = true"><v-icon left>$save</v-icon>{{ $t('form.save') }}</v-btn>
    <save-button class="pfcl1618819247" :saving="saving" style="min-width:100px" :wizard="wizard" :text="buttonText" :color="buttonColor" :icon="buttonIcon"/>
    </v-row>
    <slot>
    </slot>
    <form-section type="required" class="pfcl1618819459 my-5" :style="style" v-if="!!$slots.required">
      <slot name="required" />
    </form-section>
    <form-section type="optional" class="pfcl1618819458 my-5" :style="style" v-if="!!$slots.optional">
      <slot name="optional" />
    </form-section>
    <form-section type="basic" class="pfcl1618819457 my-5" :style="style" v-if="!!$slots.basic">
      <slot name="basic" />
    </form-section>
    <form-section type="advanced" class="pfcl1618819456 my-5" :style="style" v-if="!!$slots.advanced">
      <slot name="advanced" />
    </form-section>
    <template v-if="!wizard"> 
    <v-btn v-if="showCancel" large class="pfcl1618819230 mr-5" @click="$emit('cancel')"><v-icon left>$close</v-icon>{{$t('form.cancel')}}</v-btn>
    <save-button class="pfcl1618819223" v-if="!hideDefaultButton" :saving="saving" :wizard="wizard" :text="buttonText" :icon="buttonIcon"/>
    </template>
    <template v-else>
      <v-row no-gutters justify="end">
        <save-button class="pfcl1618819247" :saving="saving" style="min-width:100px" :wizard="wizard" :text="buttonText" :color="buttonColor" :icon="buttonIcon"/>
      </v-row>
    </template>
</v-form>

</template>
<script>

import SaveButton from '@/components/SaveButton'
import FormSection from '@/components/FormSection'
import WizardStepper from '@/components/WizardStepper'

export default {
    name: 'Form',
    components: { SaveButton, FormSection, WizardStepper },
    data() {
        return {
          nwSave: false
        }
    },
    props: { saving: Boolean, buttonText: String, buttonColor: { type: String, default: 'success'}, buttonIcon: String, hideDefaultButton: Boolean, showCancel: Boolean, 
    wizard: Boolean, wizardSteps: Array, allowEditable: Boolean, lastEditableStep: Number, step: Number, hideCancel: Boolean, maxWidth: Number },
    computed: {
      style() {
        let s = {};
        if(this.maxWidth) {
          s['max-width'] = `${this.maxWidth}px`;
        }
        return s;
      }
    },
    methods: {
        save() {
            if(!this.$refs.form.validate()) {
                console.debug('Form is not valid');
                return;
            }  
            this.$emit('save', this.nwSave);
            this.nwSave = false;
        }
    }
}
</script>